<template>
  <div class="multiple">
    <div class="wrapper" v-for="response in choices" :key="response.value">
      <vv-checkbox-bubble
        :name="response.label"
        :label="response.label"
        :value="response.label"
        :modelValue="modelValue(response)"
        @change="handleChange"
      />
    </div>
  </div>
</template>

<script>
import { VvCheckboxBubble } from '@/components/common'

export default {
  name: 'MultipleBubble',
  components: { VvCheckboxBubble },
  props: {
    expectedResponse: {
      type: Object,
      required: true,
      validator(value) {
        if (!value.hasOwnProperty('choices')) return false

        return Object.values(value.choices).every(choice => typeof choice === 'number')
      }
    },
    choices: {
      type: Array,
      required: true,
      validator(value) {
        return Array.isArray(value) && value.length > 0
      }
    },
    value: {
      type: Array,
      required: false,
      default: null
    }
  },
  mounted() {
    if (Array.isArray(this.value)) {
      this.responses = this.value
    }
  },
  methods: {
    modelValue(value) {
      if (Array.isArray(this.value)) {
        return this.value.includes(value)
      }

      return false
    },
    isCorrect(userChoices) {
      const goodResponses = this.expectedResponse.choices

      if (userChoices.length != goodResponses.length) return false

      for (let i = 0; i < userChoices.length; i++) {
        let index = -1
        for (let y = 0; y < this.choices.length; y++) {
          if (this.choices[y].label == userChoices[i]) {
            index = y
            break
          }
        }
        if (!goodResponses.includes(index)) return false
      }
      return true
    },
    handleChange(choice) {
      const value = Array.isArray(this.value) ? this.value : []
      const userChoice = choice

      if (value.includes(userChoice)) {
        let index = -1
        for (let i = 0; i < value.length; i++) {
          if (value[i] == userChoice) index = i
        }

        value.splice(index, 1)
      } else {
        value.push(userChoice)
      }
      const correct = this.isCorrect(value)
      this.value = value
      this.$emit('change', { value, correct })
    }
  }
}
</script>

<style lang="scss" scoped>
.multiple {
  width: 100%;
  text-align: left;

  .wrapper {
    display: inline-block;
    text-align: center;
    width: 49%;
  }
}
</style>
